import { ReactComponent as CheckmarkBold } from 'assets/icons/icon-checkmark-bold.svg';

export default CheckmarkBold;
